import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetCompanyInfo } from './company.actions';
import { Injectable } from '@angular/core';
import { ItemPlace } from 'glamera-shared';

export interface CompanyStateModel {
  identifier: string;
  name: string;
  description?: any;
  logo?: any;
  branchesCount: number;
  mainBranch: MainBranchStateModel;
  place: ItemPlace;
}

export interface WorkingHourStateModel {
  day: string;
  from: string;
  to: string;
  isClosed: boolean;
  isToday: boolean;
}

export interface MainBranchStateModel {
  id: number;
  name: string;
  address: string;
  googleMapsLink?: string;
  logo: string;
  slides: string[];
  workingHours: WorkingHourStateModel[];
  isOpen: boolean;
  nextOpenTime?: string;
  place: ItemPlace;
}

@Injectable()
@State<CompanyStateModel>({
  name: 'company',
  defaults: {
    identifier: '',
    name: '',
    branchesCount: 0,
    mainBranch: {
      id: 0,
      name: '',
      address: '',
      googleMapsLink: '',
      logo: '',
      slides: [],
      workingHours: [],
      isOpen: false,
      nextOpenTime: '',
      place: ItemPlace.OnSite,
    },
    place: ItemPlace.OnSite,
  },
})
export class CompanyState {
  constructor() // private companyService: CompanyService
  {}

  @Selector()
  static identifier(state: CompanyStateModel) {
    return state.identifier;
  }

  @Action(SetCompanyInfo)
  setCompanyInfo(
    ctx: StateContext<CompanyStateModel>,
    { payload }: SetCompanyInfo
  ) {
    // return this.companyService.getCompanyInfo(payload).subscribe((res) => {
    //   ctx.patchState(res.data);
    // });
  }
}
